<template>
  <div>
    <div v-html="$t('home.summary')"></div>

    <h3 v-html="$t('plan.keep.title')"></h3>
    <table class="table table-bordered">
      <tbody>
        <tr>
          <td class="w-50">
            <ul>
              <li
                v-for="k in ['agenda', 'carte', 'date', 'drive','mindmap',
                             'pad', 'talk', 'vox']"
                :id="$t(`txt.${k}`, '-l')"
                :key="k"
              >
                <i :class="`${$t(`icon.${k}`)} fa-2x d-block fc-g6`"></i>
                <span v-html="$t(`color.${k}`)"></span>
              </li>
            </ul>
          </td>
          <td class="fb-f1">
            <p v-html="$t('plan.keep.tada')"></p>
          </td>
        </tr>
        <tr>
          <td class="w-50">
            <ul>
              <li
                v-for="k in ['games', 'minetest']"
                :id="$t(`txt.${k}`, '-l')"
                :key="k"
              >
                <i :class="`${$t(`icon.${k}`)} fa-2x d-block fc-g6`"></i>
                <span v-html="$t(`color.${k}`)"></span>
              </li>
            </ul>
          </td>
          <td class="fb-f1">
            <p v-html="$t('plan.keep.moved')"></p>
          </td>
        </tr>
        <tr>
          <td class="w-50 p-0">
            <ul>
              <li
                v-for="k in ['calc', 'forms', 'git', 'listes', 'team']"
                :id="$t(`txt.${k}`, '-l')"
                :key="k"
                class="px-md-5"
              >
                <i :class="`${$t(`icon.${k}`)} fa-2x d-block fc-g6`"></i>
                <span v-html="$t(`color.${k}`)"></span>
              </li>
            </ul>
          </td>
          <td
            colspan="2"
            class="alert-info"
          >
            <p v-html="$t('plan.limit.thinking')"></p>
          </td>
        </tr>
      </tbody>
    </table>

    <h3 v-html="$t('plan.limit.title')"></h3>
    <table
      id="limit"
      class="table table-bordered"
    >
      <thead>
        <tr>
          <td
            class="invisible"
            v-html="$t('plan.services')"
          ></td>
          <td
            v-for="n in 2"
            :key="n"
            class="w-25"
            v-html="$t(`plan.limit.col[${n-1}]`)"
          ></td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="w-50 p-0">
            <ul>
              <li
                v-for="k in ['piaf']"
                :id="$t(`txt.${k}`, '-l')"
                :key="k"
                class="px-md-5"
              >
                <i :class="`${$t(`icon.${k}`)} fa-2x d-block fc-g6`"></i>
                <span v-html="$t(`color.${k}`)"></span>
              </li>
            </ul>
          </td>
          <td>
            <p v-html="$t('plan.year.start', { year: '2021' })"></p>
          </td>
          <td class="alert-info">
            <p v-html="$t('plan.limit.thinking')"></p>
          </td>
        </tr>
      </tbody>
    </table>

    <h3 v-html="$t('plan.close.title')"></h3>
    <table
      id="close"
      class="table table-bordered"
    >
      <thead>
        <tr>
          <td
            class="invisible"
            v-html="$t('plan.services')"
          ></td>
          <td
            v-for="n in 3"
            :key="n"
            v-html="$t(`plan.close.col[${n-1}]`)"
          ></td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="w-50 p-0">
            <ul>
              <li
                v-for="k in ['bee']"
                :id="$t(`txt.${k}`, '-l')"
                :key="k"
              >
                <router-link :to="$t(`txt.${k}`, '-l')">
                  <i :class="`${$t(`icon.${k}`)} fa-2x d-block fc-g6`"></i>
                  <span v-html="$t(`color.${k}`)"></span>
                </router-link>
              </li>
            </ul>
          </td>
          <td></td>
          <td>
            <p v-html="date('2019-09')"></p>
          </td>
          <td>
            <p v-html="date('2019-10')"></p>
          </td>
        </tr>
        <tr>
          <td class="w-50 p-0">
            <ul>
              <li
                v-for="k in ['news', 'story']"
                :id="$t(`txt.${k}`, '-l')"
                :key="k"
              >
                <router-link :to="$t(`txt.${k}`, '-l')">
                  <i :class="`${$t(`icon.${k}`)} fa-2x d-block fc-g6`"></i>
                  <span v-html="$t(`color.${k}`)"></span>
                </router-link>
              </li>
            </ul>
          </td>
          <td>
            <p v-html="date('2019-10')"></p>
          </td>
          <td>
            <p v-html="$t('plan.year.start', { year: '2020' })"></p>
          </td>
          <td>
            <p v-html="$t('plan.year.middle', { year: '2020' })"></p>
          </td>
        </tr>
        <tr>
          <td class="w-50 p-0">
            <ul>
              <li
                v-for="k in ['clic', 'mindmap', 'my', 'pic', 'vectoriel', ]"
                :id="$t(`txt.${k}`, '-l')"
                :key="k"
              >
                <router-link :to="$t(`txt.${k}`, '-l')">
                  <i :class="`${$t(`icon.${k}`)} fa-2x d-block fc-g6`"></i>
                  <span v-html="$t(`color.${k}`)"></span>
                  <br />
                  <small
                    v-if="k === 'mindmap'"
                    class="mt-n1 d-block text-muted"
                    v-html="$t('plan.close.mindmap')"
                  ></small>
                </router-link>
              </li>
            </ul>
          </td>
          <td>
            <p v-html="$t('plan.year.start', { year: '2020' })"></p>
          </td>
          <td>
            <p v-html="$t('plan.year.middle', { year: '2020' })"></p>
          </td>
          <td>
            <p v-html="$t('plan.year.start', { year: '2021' })"></p>
          </td>
        </tr>
        <tr>
          <td class="w-50 p-0">
            <ul>
              <li
                v-for="k in ['bag', 'bin', 'drop', 'link', 'notes', 'site', 'wiki']"
                :id="$t(`txt.${k}`, '-l')"
                :key="k"
              >
                <router-link :to="$t(`txt.${k}`, '-l')">
                  <i :class="`${$t(`icon.${k}`)} fa-2x d-block fc-g6`"></i>
                  <span v-html="$t(`color.${k}`)"></span>
                </router-link>
              </li>
            </ul>
          </td>
          <td>
            <p v-html="$t('plan.year.start', { year: '2020' })"></p>
          </td>
          <td>
            <p v-html="$t('plan.year.start', { year: '2021' })"></p>
          </td>
          <td>
            <p v-html="$t('plan.year.middle', { year: '2021' })"></p>
          </td>
        </tr>
        <tr>
          <td class="w-50 p-0">
            <ul>
              <li
                v-for="k in ['sphere']"
                :id="$t(`txt.${k}`, '-l')"
                :key="k"
              >
                <router-link :to="$t(`txt.${k}`, '-lL')">
                  <i :class="`${$t(`icon.${k}`)} fa-2x d-block fc-g6`"></i>
                  <span v-html="$t(`color.${k}`)"></span>
                </router-link>
              </li>
            </ul>
          </td>
          <td>
            <p v-html="$t('plan.year.start', { year: '2021' })"></p>
          </td>
          <td>
            <p v-html="$t('plan.year.start', { year: '2021' })"></p>
          </td>
          <td>
            <p v-html="$t('plan.year.end', { year: '2021' })"></p>
          </td>
        </tr>
        <tr>
          <td class="w-50 p-0">
            <ul>
              <li
                v-for="k in ['board', 'bookin', 'maestro', 'memo', 'slides']"
                :id="$t(`txt.${k}`, '-l')"
                :key="k"
              >
                <router-link :to="$t(`txt.${k}`, '-l')">
                  <i :class="`${$t(`icon.${k}`)} fa-2x d-block fc-g6`"></i>
                  <span v-html="$t(`color.${k}`)"></span>
                </router-link>
              </li>
            </ul>
          </td>
          <td>
            <p v-html="$t('plan.year.start', { year: '2020' })"></p>
          </td>
          <td>
            <p v-html="$t('plan.year.start', { year: '2021' })"></p>
          </td>
          <td>
            <p v-html="$t('plan.year.start', { year: '2022' })"></p>
          </td>
        </tr>
      </tbody>
    </table>
    <p
      class="signature text-right"
      v-html="$t('home.update', {date : $t('meta.date-edit')})"
    ></p>
  </div>
</template>

<script>
export default {
  methods: {
    date(date) {
      return this.$t(new Date(date).toLocaleDateString(this.$t('lang'), {
        year: 'numeric',
        month: 'long',
      }), '-K');
    },
  },
};
</script>
